module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dVtEm"))).then(() => parcelRequire('1iHdE'));